import { render, staticRenderFns } from "./TextImageSection.vue?vue&type=template&id=7d13a7d4&scoped=true"
import script from "./TextImageSection.vue?vue&type=script&lang=ts"
export * from "./TextImageSection.vue?vue&type=script&lang=ts"
import style0 from "./TextImageSection.vue?vue&type=style&index=0&id=7d13a7d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d13a7d4",
  null
  
)

export default component.exports